import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestAnnouncementActive = {
    path: "/announcement/:slug/active",
    method: RouteHttpVerb.POST
};
export { locationRestAnnouncementActive };
